import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { handleChangeDataModalAddToStock } from '../../../../redux/actions/partials/modals/modalAddToStock';
import { handleChangeDataProductsPage } from '../../../../redux/actions/pages/products';
import { ADD_PRODUCT_TO_STOCK_POST } from '../../../../apis';
import apiRequest from '../../../../utils/apiRequest'; 


const ModalAddToStock = (props) => {

	const dispatch = useDispatch();

	const { isOpen, product, inventory, price, priceOld, productKey } = useSelector(state => state.modalAddToStock);
	const { token } = useSelector(state => state.login);
	const { allProducts } = useSelector(state => state.products);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);

	const handleClose = () => {
        dispatch(handleChangeDataModalAddToStock('isOpen', false));
    };    

    const handleChangeInputs = (event) => {
    	const {name, value} = event.target;
    	dispatch(handleChangeDataModalAddToStock(name, value));
    };

    const handelNumericInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeDataModalAddToStock(name, addCommas(removeNonNumeric(changeNumberPersianAndArabic(value))) ));
    };

    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }

    const handleSubmitForm = () => {
    	if(! isBackdropLoading) {
            apiRequest({
                dispatch,
                endpoint: ADD_PRODUCT_TO_STOCK_POST,
                method: 'post',
                data: {
                	product: product.productId,
                	variant: product.variantId,
                	inventory, 
                	price: removeNonNumeric(changeNumberPersianAndArabic(price)), 
                	priceOld: removeNonNumeric(changeNumberPersianAndArabic(priceOld))
                },
                token: token,
                successMessage: null,
                onSuccess: (res) => {
                	let newProoducts = [...allProducts];
                	newProoducts[productKey].inSellerStock = true;
                    dispatch(handleChangeDataProductsPage('allProducts', newProoducts));

                    dispatch(handleChangeDataModalAddToStock('inventory', ''));
                    dispatch(handleChangeDataModalAddToStock('price', ''));
                    dispatch(handleChangeDataModalAddToStock('priceOld', ''));
                    dispatch(handleChangeDataModalAddToStock('productKey', 0));
                    dispatch(handleChangeDataModalAddToStock('isOpen', false));
                },
            });
        }
    	
    };

    return (
        <Modal show={isOpen} onHide={handleClose} className={`modal fade text-xs-left ${isOpen ? 'in' : ''}`} dialogClassName='modal-dialog modal-dialog-centered modal-fullscreen-sm-down' style={{marginTop: '90px'}}>
        	<div className="modal-dialog modal-lg" role="document" style={{marginTop: '0', marginBottom: '0'}}>
        		<div className="modal-content" >
        			<div className="modal-header">
		                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
		                    <span aria-hidden="true">&times;</span>
		                </button>
		                <h4 className="modal-title" id="myModalLabel17">افزودن محصول به انبار</h4>
		            </div>
		            <form>
			            <div className="modal-body pb-0">
			            	<label>موجودی</label>
							<div className="form-group">
								<input type="number" placeholder="" className="form-control" name="inventory" value={inventory} onChange={handleChangeInputs} />
							</div>
			            </div>
			            <div className="modal-body py-0">
			            	<label>قیمت نهایی</label>
							<div className="form-group">
								<input type="text" inputMode="numeric" placeholder="تومان" className="form-control" name="price" value={price} onChange={handelNumericInputs} />
							</div>
			            </div>
			            <div className="modal-body py-0">
			            	<label>قیمت قبل از تخفیف (اختیاری)</label>
							<div className="form-group">
								<input type="text" inputMode="numeric" placeholder="تومان" className="form-control" name="priceOld" value={priceOld} onChange={handelNumericInputs} />
							</div>
			            </div>
			            <div className="modal-footer">
			                <button type="button" className="btn grey btn-outline-secondary" data-dismiss="modal" onClick={handleClose}>بستن</button>
			                <button type="button" className="btn btn-outline-primary ml-2" data-dismiss="modal" onClick={handleSubmitForm}>ویرایش</button>
			            </div>
		            </form>
        		</div>
        	</div>

        </Modal>
    );
}

export default ModalAddToStock;
